module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAABGdBTUEAALGPC/xhBQAAAK1JREFUGBljNKv7f4qBgcEUiAkCRgaGs3I6DOZMQIYIQdVQBf8ZGQRXhTL8Y2JgYggAavxMSCNIDSMjQyAjI+N/ppMNjJcYmRnCgYJ/cWkEyYHUgNSC1DCBiBP1jNuBrDwQGysAyoHVQCXBmkBsoCnTgNZPQNcEEgPJIYvDNYEEPRkZioGKNsEUgNggMRgfRgOdiwrcuv9zf/zMsBoYUowCPAwhu0oZv6KqYGAAALVRJlBYvfFQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/all_icon_open_selected.png
// module id = D3qG
// module chunks = 1